/**
 * Q8 — Empty-state overlay when no visible 3D model layers are loaded.
 */

import { tokens } from '@/design';

export function EmptyScene3DState() {
  return (
    <div
      role="status"
      tabIndex={0}
      data-testid="empty-scene-3d-state"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: tokens.zIndex.panel - 1,
      }}
    >
      <div
        style={{
          pointerEvents: 'auto',
          maxWidth: 360,
          padding: tokens.space[4],
          borderRadius: tokens.radius.md,
          border: tokens.border.thin,
          background: tokens.color.surface[1],
          textAlign: 'center',
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: tokens.font.size.md,
            fontWeight: tokens.font.weight.medium,
            color: tokens.color.ink.primary,
          }}
        >
          No 3D content loaded
        </p>
        <p
          style={{
            margin: `${tokens.space[2]}px 0 0`,
            fontSize: tokens.font.size.sm,
            color: tokens.color.ink.secondary,
          }}
        >
          Add a 3D Tiles or BIM layer from the panel
        </p>
      </div>
    </div>
  );
}
